import * as React from "react"

const SvgTextBold = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.8 19.286q-.825 0-1.413-.588a1.93 1.93 0 0 1-.587-1.412v-10q0-.825.587-1.413A1.93 1.93 0 0 1 8.8 5.286h3.525q1.624 0 3 1 1.374.999 1.375 2.775 0 1.275-.575 1.962t-1.075.988q.624.275 1.387 1.025t.763 2.25q0 2.224-1.625 3.112t-3.05.888zm1.025-2.8h2.6q1.2 0 1.462-.613.263-.612.263-.887 0-.276-.263-.888-.262-.612-1.537-.612H9.825zm0-5.7h2.325q.825 0 1.2-.425a1.4 1.4 0 0 0 .375-.95q0-.6-.425-.975t-1.1-.375H9.825z" />
  </svg>
)
export default SvgTextBold
